import { Button, Drawer, Space } from "antd";
import moment from "moment";
import InfoItem from "../../../../components/common/InfoItem";
import Loader from "../../../../components/ui/Loader";
import { dateFormat, dbDateFormat } from "../../../../constants/constants";
import { useGetPettyCashDetailsQuery } from "../../../../features/pettyCash/pettyCash";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import { ModalComponentProps } from "../../../../types";
import {
  formatSouthAsianWithDecimals,
  underscoreToCapitalizeString,
} from "../../../../utils/utils";
import { pettyCashPaymentStatusList, pettyCashStatusList } from "../PettyCash";
import SendSingleDisbursement from "./SendSingleDisbursement";

export type SingleSelectedDataType = {
  amount: number;
  id: string;
  userInfo: {
    name: string;
    due_date: string;
  };
};

export default function PettyCashDetails({
  handleClose,
  data,
  ...rest
}: ModalComponentProps<number>) {
  const {
    open,
    handleOpen,
    handleClose: handleCloseDetails,
  } = useModal<SingleSelectedDataType, "SEND_DISBURSEMENT">();
  const {
    isLoading,
    isError,
    error,
    data: detailsData,
  } = useGetPettyCashDetailsQuery(Number(data), {
    skip: !data,
  });
  useError(isError, error, "Get petty cash data fail");

  const details = detailsData?.data?.pettyCash;

  return (
    <Drawer
      title="Petty Cash Request Details"
      placement="right"
      width={480}
      className="petty_cash"
      onClose={handleClose}
      {...rest}
    >
      {open?.type === "SEND_DISBURSEMENT" ? (
        <SendSingleDisbursement
          open={open?.open}
          data={open?.data}
          handleClose={handleCloseDetails}
        />
      ) : null}
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <InfoItem title="Status">
            {details?.status ? (
              <span className={pettyCashStatusList[details?.status].class}>
                {pettyCashStatusList[details?.status].text ||
                  underscoreToCapitalizeString(details?.status)}
              </span>
            ) : (
              "-"
            )}
          </InfoItem>
          <InfoItem title="Payment Status">
            {details?.payment_status ? (
              <span
                className={
                  pettyCashPaymentStatusList[details?.payment_status].class
                }
              >
                {pettyCashPaymentStatusList?.[details?.payment_status]?.text ||
                  underscoreToCapitalizeString(details?.payment_status || "-")}
              </span>
            ) : (
              "-"
            )}
          </InfoItem>
          {/* <InfoItem title="Request ID"></InfoItem> */}
          <InfoItem title="Request Title">{details?.title}</InfoItem>
          <InfoItem title="Amount">
            <span className="text-violet-500 font-semibold">
              ৳{formatSouthAsianWithDecimals(Number(details?.amount))}
            </span>
          </InfoItem>
          {/* <InfoItem title="Txn ID">{details?.unique_batch_code}</InfoItem> */}
          <InfoItem title="Due Date">
            {details?.due_date
              ? moment.utc(details?.due_date, dbDateFormat).format(dateFormat)
              : "-"}
          </InfoItem>
          <InfoItem title="Note">{details?.remarks}</InfoItem>

          <Space className="w-full mt-6" size={12}>
            <Button
              className="normal-dark-button modal-button"
              onClick={handleClose}
              size="middle"
            >
              Cancel
            </Button>

            <Button
              className="modal-button"
              type="primary"
              htmlType="submit"
              size="middle"
              disabled={
                details?.status === "approved" &&
                details?.payment_status === "pending"
                  ? false
                  : true
              }
              onClick={() =>
                handleOpen({
                  type: "SEND_DISBURSEMENT",
                  data: {
                    amount: Number(details?.amount),
                    id: String(details?.id),
                    userInfo: {
                      name:
                        details?.business_member?.member?.profile?.name || "",
                      due_date: details?.due_date || "",
                    },
                  },
                })
              }
            >
              Send for Disbursement
            </Button>
          </Space>
        </>
      )}
    </Drawer>
  );
}
